import { render, staticRenderFns } from "./GastosRepresentacion.vue?vue&type=template&id=5e6f1e00&scoped=true&"
import script from "./GastosRepresentacion.vue?vue&type=script&lang=js&"
export * from "./GastosRepresentacion.vue?vue&type=script&lang=js&"
import style0 from "./GastosRepresentacion.vue?vue&type=style&index=0&id=5e6f1e00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6f1e00",
  null
  
)

component.options.__file = "GastosRepresentacion.vue"
export default component.exports